import React, { Component } from 'react';

class renderPrevImagem extends Component {
    render() {
        return (

            <div className="communication-message">
                        <div className="author author-with-link author-with-line "></div>
                        <div className="communication-complement-form">
                            <div className="selected_img_post">
                            <img className="img-rounded" width="120" src={this.props.prevImg} alt="Imagem"/>
                            <p><a href={void(0)} onClick={this.props.funcao}>Excluir</a></p>
                            </div>
                        </div>
                    </div>
        );
    }
}

export default renderPrevImagem;


// WEBPACK FOOTER //
// ./src/container/renderPrevImagemTimeLine.js